import { createElement } from 'react';

import { cn } from '@/shared/lib/cn';

import { useModuleIcon } from '../moduleIcon';

/** A module's icon on a tinted tile (notifications without an actor, filters). */
export function ModuleIconTile({
  module,
  size = 'md',
  className,
}: {
  module: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const Icon = useModuleIcon(module);
  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full bg-brand-soft text-brand-text',
        size === 'sm' && 'size-6 [&_svg]:size-3.5',
        size === 'md' && 'size-8 [&_svg]:size-4',
        size === 'lg' && 'size-10 [&_svg]:size-[1.125rem]',
        className,
      )}
    >
      {createElement(Icon, { strokeWidth: 1.9 })}
    </span>
  );
}

/** A module's icon as a small badge on an avatar. */
export function ModuleIconBadge({ module, className }: { module: string; className?: string }) {
  const Icon = useModuleIcon(module);
  return (
    <span
      aria-hidden
      className={cn(
        'absolute -right-1 -bottom-1 inline-flex size-[1.125rem] items-center justify-center rounded-full bg-background text-brand-text shadow-xs ring-1 ring-border',
        className,
      )}
    >
      {createElement(Icon, { className: 'size-2.5', strokeWidth: 2.2 })}
    </span>
  );
}
